"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4817],{

/***/ 24817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75681);




var Heading = function(param) {
    var item = param.item;
    var tagEntry = "<".concat(item.tag, ">").concat(item.headingText, "</").concat(item.tag, ">");
    var setStyles = item.settings ? (0,_services_utils__WEBPACK_IMPORTED_MODULE_2__/* .convertStyles */ .WN)(item.settings) : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            //@ts-ignore
            "data-aos": setStyles === null || setStyles === void 0 ? void 0 : setStyles.animationAos["data-aos"],
            //@ts-ignore
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                width: "100%"
            }, setStyles.parentStyles),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                //@ts-ignore
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, setStyles.styles),
                dangerouslySetInnerHTML: {
                    __html: tagEntry
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Heading);


/***/ })

}]);